import React, { useContext } from "react";
import style from "./index.module.scss";
import { Button, Icon, Popover, Tooltip } from "antd";
import { ColumnProps } from "antd/lib/table/interface";
import { CourseContext } from "../../../../../Store";
import { useHistory } from "react-router-dom";
import CommonTable from "components/CommonTable";
import MultiLineColumn from "components/MultiLineColumn";
import OverLengthColumn from "components/OverLengthColumn";
import { isTrue } from "service/service";
import { groupActivityDetailStaticsList } from "service/group";

interface TableListProps {
    list: groupActivityDetailStaticsList[]; //列表
}

export default function TableList({ list }: TableListProps) {
    const { basename } = useContext(CourseContext);
    const history = useHistory();

    const memberListRender = (
        val: string,
        item: groupActivityDetailStaticsList
    ) => {
        return (
            <Popover
                placement="bottom"
                className={style.popover}
                overlayClassName={style.popoverWrapper}
                content={item.memberList?.map((item: any) => (
                    <div key={item.id} className={style.popoverItem}>
                        <span className={style.icon}>
                            {isTrue(item.isGroupLeader) ? (
                                "组长"
                            ) : (
                                <Icon type="user" />
                            )}
                        </span>
                        <Tooltip title={item.name}>
                            <span className={style.name}>{item.name}</span>
                        </Tooltip>
                    </div>
                ))}>
                <Button>{val}</Button>
            </Popover>
        );
    };

    const columns: ColumnProps<groupActivityDetailStaticsList>[] = [
        {
            title: "序号",
            dataIndex: "index",
            align: "center",
            render: (text, item, index) => index + 1
        },
        {
            title: "组名",
            dataIndex: "groupName",
            align: "center",
            render: text => <OverLengthColumn value={text} />
        },
        {
            title: "组长",
            dataIndex: "groupLeaderNo",
            align: "left",
            render: (val, item) => (
                <MultiLineColumn name={item.groupLeaderName} no={val} />
            )
        },
        {
            title: "组员人数",
            dataIndex: "groupCount",
            align: "center",
            width: 100,
            render: (val, item) => memberListRender(val, item)
        },
        {
            title: "参与状态",
            dataIndex: "status",
            align: "center",
            render: text => <div>{text !== "2" ? "未参与" : "已参与"}</div>
        },
        {
            title: "参与时间",
            dataIndex: "partInTimeStr",
            align: "center",
            render: text => <div>{text ? text : "--"}</div>
        },
        {
            title: "小组得分",
            dataIndex: "groupScore",
            align: "center",
            render: text => <div>{text ? text : "--"}</div>
        },
        {
            title: "操作",
            align: "center",
            render: (_, item) => {
                return (
                    <div className={style.operation}>
                        {item.status !== "2" && <span>未参与</span>}
                        {item.status === "2" && item.hasCorrected === "0" && (
                            <Button
                                type="link"
                                onClick={() => gotoReview(item)}>
                                批阅
                            </Button>
                        )}
                        {item.status === "2" && item.hasCorrected === "1" && (
                            <Button
                                type="link"
                                onClick={() => gotoReview(item)}>
                                重批
                            </Button>
                        )}
                    </div>
                );
            }
        }
    ];

    function gotoReview(item: groupActivityDetailStaticsList) {
        history.push(
            `${basename}/group/detail/${item.activityId}/review/${item.taskId}/${item.groupId}/${item.statusId}/${item.homeworkId}`
        );
    }

    return (
        <div className={style.root}>
            <CommonTable
                columns={columns}
                dataSource={list}
                rowKey="groupId"
                pagination={false}
                height="480px"
            />
        </div>
    );
}
